import { AcDataGrid } from '@components'
import { useStore } from '@hooks/use-store'
import { ROUTE_PATHS } from '@constants'


export const CustomerUserListTab = () => {
  const { users } = useStore()

  return (
    <div style={{ marginTop: 24 }}>
      <AcDataGrid
        store={users.data_grid_customers}
        detailPath={ROUTE_PATHS.USER_PROFILE}
      />
    </div>
  )
}
